// Phase 7 — Mugizh-admin My Orders (static mockup) migrated to shadcn/Tailwind.
//
// No dispatch/API — hardcoded rows. UI only: antd Table/Dropdown/Menu → shared
// DataTable + DropdownMenu. The mock `data` is unchanged.
import React, { useMemo } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { MoreVertical } from 'lucide-react';
import AppConstant from '../Globals/AppConstants';
import { DataTable } from '../shared/data-table';
import { PageHeader } from '../shared/page-header';
import { Button } from 'ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'ui/dropdown-menu';

const MyOrdersList = () => {
  const data = Array.from({ length: 10 }).map(() => ({
    invoiceId: 'INVCE-03848047449',
    purchasedDate: '22 Sep 2022, 12.30 PM',
    customerName: 'loren ipsum',
    mobileNo: '9988776655',
    item: '04',
    totalAmount: '1,200',
  }));

  const columns = useMemo<ColumnDef<any, any>[]>(
    () => [
      { id: 'invoiceId', header: 'Invoice ID', cell: ({ row }) => row.original?.invoiceId },
      { id: 'purchasedDate', header: 'Purchased Date', cell: ({ row }) => row.original?.purchasedDate },
      {
        id: 'customerName',
        header: 'Customer Name',
        cell: ({ row }) => <span className="text-primary">{row.original?.customerName}</span>,
      },
      { id: 'mobileNo', header: 'Mobile No.', cell: ({ row }) => row.original?.mobileNo },
      { id: 'item', header: 'Item', cell: ({ row }) => row.original?.item },
      { id: 'totalAmount', header: 'Total Amount', cell: ({ row }) => <span className="tabular-nums">{row.original?.totalAmount}</span> },
      {
        id: 'action',
        header: 'Action',
        cell: () => (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" aria-label="Row actions">
                <MoreVertical className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem>{AppConstant?.edit}</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ),
      },
    ],
    []
  );

  return (
    <div className="mz h-full overflow-y-auto px-6 py-4">
      <PageHeader title="Orders" />
      <DataTable columns={columns} data={data} />
    </div>
  );
};

export default MyOrdersList;
